import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import camisa from '@/assets/camisa.png';
import relogio from '@/assets/relogio.png';
import sacola from '@/assets/sacola.png';
import { Crm } from '@/services/CrmService';

interface ProfileStatsProps {
  crm: Pick<Crm, 'firstPurchaseDate' | 'lastPurchaseDate' | 'totalSales'>;
}
export function ProfileStats({ crm }: ProfileStatsProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Profiles.components.ProfileModal',
  });

  return (
    <div className="flex items-center gap-[10px]">
      <div className="flex w-[180px] items-center gap-2 rounded-xl border px-3 py-4">
        <img src={sacola} alt="" className="h-8 w-8" />

        <div>
          <span className="block text-[14px] text-muted-foreground">
            {t('totalSales')}
          </span>

          <span className="block text-[14px] text-muted-foreground">
            {t('totalSalesCount', { count: crm?.totalSales ?? 0 })}
          </span>
        </div>
      </div>

      <div className="flex w-[180px] items-center gap-2 rounded-xl border px-3 py-4">
        <img src={relogio} alt="" className="h-6 w-6" />

        <div>
          <span className="block text-[14px] text-muted-foreground">
            {t('lastSale')}
          </span>

          <span className="block text-[14px] text-muted-foreground">
            {t('lastSaleDate', {
              date: crm?.lastPurchaseDate
                ? format(crm.lastPurchaseDate, 'dd/MM/yyyy')
                : '?',
            })}
          </span>
        </div>
      </div>

      <div className="flex w-[180px] items-center gap-2 rounded-xl border px-3 py-4">
        <img src={camisa} alt="" className="h-8 w-8" />

        <div>
          <span className="block text-[14px] text-muted-foreground">
            {t('sinceDate', {
              date: crm?.firstPurchaseDate
                ? new Date(crm.firstPurchaseDate).getFullYear().toString()
                : '?',
            })}
          </span>
        </div>
      </div>
    </div>
  );
}
